// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"572d6130","239":"2a1af8b5","732":"89b43db3"}[chunkId] + ".chunk.js";
};